// src/components/game/ui/SocialBlackMarket.jsx
import React, { useState } from 'react';
import { ASSETS } from '../../../utils/GameAssets';

// The "Cheat Codes" for real life
const TOOLS_FOR_SALE = [
    { id: 'admin', name: "Admin Resource Tool", cost: 1000, img: ASSETS.TOOLS.Admin, desc: "Bypass bureaucracy instantly. Guarantees Age 2 Entry." },
    { id: 'promotion', name: "Hairy Hand of Promotion", cost: 2500, img: ASSETS.TOOLS.HairyHand, desc: "Nepotism at its finest. Skip the line." },
    { id: 'codex', name: "Whisperer's Codex", cost: 1500, img: ASSETS.TOOLS.Codex, desc: "Secret knowledge of the old laws." },
    { id: 'pass', name: "Trough Pass", cost: 800, img: ASSETS.TOOLS.Pass, desc: "Access to subsidized rations." },
    { id: 'charter', name: "Ancestral Charter", cost: 3000, img: ASSETS.TOOLS.Charter, desc: "Proof of noble lineage. Instant Integrity boost." },
];

export default function SocialBlackMarket({ dispatch, currentResources, ownedTools, onExit }) {
    const [shared, setShared] = useState(false);

    const handleShare = (platform) => {
        // VIRAL LOOP: Fake the share, reward the player
        // In production, this would open a real share window
        const url = encodeURIComponent("I just survived the Corporate Fracture in Autarky. Can you?");
        window.open(`https://twitter.com/intent/tweet?text=${url}`, '_blank');
        
        // Reward instantly to dopamine hit
        dispatch({ type: 'UPDATE_STATS', payload: { resources: 1000 } }); 
        setShared(true);
    };

    const buyTool = (tool) => {
        if (currentResources >= tool.cost) {
            dispatch({ 
                type: 'UPDATE_STATS', 
                payload: { resources: -tool.cost, tool: tool.id, integrity: 10 } 
            });
        } else {
            alert("INSUFFICIENT FUNDS. Share the game to earn capital.");
        }
    };

    return (
        <div className="absolute inset-0 bg-black/95 z-50 flex flex-col items-center justify-center p-6 animate-fade-in">
            <h2 className="text-4xl font-bold text-purple-500 mb-2 uppercase tracking-widest">The Black Market</h2>
            <p className="text-gray-400 mb-8 text-center max-w-xl">
                "The system collapsed, but connections remain. Purchase survival assets here. <br/>
                <span className="text-white font-bold">Short on cash? Spread the signal to earn influence.</span>"
            </p>

            {/* VIRAL SECTION */}
            <div className="bg-purple-900/30 border border-purple-500 p-6 rounded-xl w-full max-w-4xl mb-8 flex justify-between items-center">
                <div>
                    <h3 className="text-xl font-bold text-white">EARN 1000 CREDITS</h3>
                    <p className="text-sm text-purple-300">Share your survival status on the network.</p>
                </div>
                <div className="flex gap-4">
                    <button onClick={() => handleShare('x')} className="px-6 py-2 bg-black border border-gray-600 hover:border-white text-white rounded font-bold">SHARE ON X</button>
                    <button onClick={() => handleShare('linkedin')} className="px-6 py-2 bg-blue-700 hover:bg-blue-600 text-white rounded font-bold">LINKEDIN</button>
                </div>
            </div>

            {/* SHOP SECTION */}
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 w-full max-w-6xl overflow-y-auto">
                {TOOLS_FOR_SALE.map(tool => {
                    const isOwned = ownedTools.includes(tool.id);
                    const canAfford = currentResources >= tool.cost;

                    return (
                        <div key={tool.id} className={`p-4 border rounded-lg flex flex-col items-center text-center transition-all ${isOwned ? 'border-green-500 bg-green-900/20' : 'border-gray-700 bg-gray-900'}`}>
                            <div className="w-24 h-24 mb-4 relative">
                                <img src={tool.img} alt={tool.name} className="w-full h-full object-contain" />
                                {isOwned && <div className="absolute inset-0 flex items-center justify-center bg-black/60 text-green-400 font-bold rotate-[-15deg] border-2 border-green-500 rounded">OWNED</div>}
                            </div>
                            <h4 className="text-sm font-bold text-white mb-1">{tool.name}</h4>
                            <p className="text-[10px] text-gray-400 mb-4 h-8">{tool.desc}</p>
                            
                            {!isOwned && (
                                <button 
                                    onClick={() => buyTool(tool)}
                                    className={`w-full py-2 text-xs font-bold rounded ${canAfford ? 'bg-purple-600 hover:bg-purple-500 text-white' : 'bg-gray-700 text-gray-500'}`}
                                >
                                    BUY ${tool.cost}
                                </button>
                            )}
                        </div>
                    );
                })}
            </div>

            <button 
                onClick={onExit} 
                className="mt-8 px-12 py-4 bg-red-600 hover:bg-red-500 text-white font-bold rounded-full text-xl shadow-[0_0_20px_rgba(220,38,38,0.5)] animate-pulse"
            >
                PROCEED TO AGE 2 &raquo;
            </button>
        </div>
    );
}